var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Dialog } from "@mui/material";
import ReservationProfile from "./ReservationProfile";
import { useTrackScreenVisit } from "../../utils/analytics.util";
import { useShowNewProfile } from "./newProfileToggle";
// Esc while typing (a note, an edit form) would close the dialog and lose the text; there it is left to the field.
var isTyping = function () {
    var element = document.activeElement;
    return !!element && (element.tagName === 'INPUT' || element.tagName === 'TEXTAREA' || element.isContentEditable);
};
var ProfilePreviewDialog = function (props) {
    var _a;
    useTrackScreenVisit((props.open && ((_a = props.profile) === null || _a === void 0 ? void 0 : _a.id)) ? 'profile preview dialog' : '');
    var showNewProfile = useShowNewProfile();
    return (_jsx(Dialog, __assign({ open: props.open, onClose: function (_event, reason) {
            var _a;
            if (reason === 'escapeKeyDown' && isTyping())
                return;
            (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props);
        }, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", 
        // max width must be 1336px
        fullWidth: true, maxWidth: 'lg', 
        // The new profile's sections load after it opens: a fixed height, as in the reservation dialog, keeps
        // the dialog from growing while they arrive. The legacy profile keeps its content height.
        PaperProps: showNewProfile ? { sx: { height: { md: 'min(900px, calc(100% - 64px))' } } } : undefined }, { children: _jsx(ReservationProfile, { profile: props.profile, mode: 'full', setProfile: props.setProfile, extraActions: props.extraActions, reservationId: props.reservationId, onClose: props.onClose }) })));
};
export default ProfilePreviewDialog;
